import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from '@dc/ui-library/src/molecules/Icon/Icon';
import { touchDeviceType } from '../filterHelpers';
import { filterOptionPropTypes } from '../propTypes';

class FilterClosed extends PureComponent {
  render() {
    return (
      <nav className="dc-filter dc-filter--closed">
        <h3
          className="dc-filter__header"
          onClick={this.props.toggleOptionsListVisibility}
          onKeyPress={this.props.toggleOptionsListVisibility}
        >
          <span className="dc-filter__header--closed">
            {this.props.label}
          </span>
          {touchDeviceType(this.props.deviceType) &&
          <span className="dc-filter__header-selected-options">
            {this.props.selectedOptions}
          </span>
          }
          <Icon
            icon="ChevronRight"
            size="large"
            rotate={touchDeviceType(this.props.deviceType) ? 0 : 90}
          />
        </h3>
      </nav>
    );
  }
}

FilterClosed.displayName = 'FilterClosed';

FilterClosed.propTypes = {
  label: PropTypes.string.isRequired,
  selectedOptions: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  toggleOptionsListVisibility: PropTypes.func,
  deviceType: PropTypes.oneOf(['wide', 'desktop', 'tablet', 'mobile']).isRequired,
  options: PropTypes.arrayOf(filterOptionPropTypes).isRequired
};

FilterClosed.defaultProps = {
  toggleOptionsListVisibility: () => {},
  selectedOptions: ''
};

export default FilterClosed;
